import {Controller} from "@stimulus/core"

export default class extends Controller {
    connect() {
            (function (w, d, u) {
                if (window.BX && window.BX.SiteButton) {
                    window.BX = undefined;
                }

                var s = d.createElement('script');
                s.async = true;
                s.src = u + '?' + (Date.now() / 60000 | 0);
                var h = d.getElementsByTagName('script')[0];
                h.parentNode.insertBefore(s, h);
            })(window, document, 'https://cdn-ru.bitrix24.ru/b19976816/crm/site_button/loader_3_xaqcrj.js');

        return true
    }
}
